import { classes } from 'html-classes';
import { JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { MobileActionDialog } from '~/components/MobileActionDialog';
import BottomNavigationBarV2 from '~/pages/Root/BottomNavigationBar/BottomNavigationBarV2';
import eventEmitter, { EventsName } from '~/services/Events';
import { bottomNavigationStore } from '~/stores/BottomNavigationStore';

import { MobileFiltersProps } from './interfaces';
import styles from './MobileFilters.module.scss';

const MobileFilters = (props: MobileFiltersProps): JSX.Element => {
  const { open, onClose, onReset, onApply, className, children, results } =
    props;

  const { t } = useTranslation();

  useEffect(() => {
    bottomNavigationStore.setFilters(!!open);
  }, [open]);

  useEffect(() => {
    eventEmitter.on(EventsName.APPLY_FILTERS, () => {
      onApply?.();
    });

    eventEmitter.on(EventsName.RESET_FILTERS, () => {
      onReset?.();
    });

    return () => {
      eventEmitter.off(EventsName.APPLY_FILTERS);
      eventEmitter.off(EventsName.RESET_FILTERS);
    };
  }, [open]);

  return (
    <MobileActionDialog
      open={open}
      onClose={onClose}
      className={className}
      title={
        <>
          <h2 className={styles.headerTitle}>{t('filter')}</h2>
          <span className={styles.headerCaption}>
            {results}&nbsp;{t('results')}
          </span>
        </>
      }
      footer={
        company.newDesignSystemEnabled ? (
          <BottomNavigationBarV2 />
        ) : (
          <>
            <button
              type="button"
              className="button _bordered"
              onClick={onReset}
            >
              {t('resetAll')}
            </button>
            <button
              type="button"
              className={classes(['button', '_primary', styles.applyButton])}
              onClick={onApply}
            >
              {t('applyFilters')}
            </button>
          </>
        )
      }
    >
      {children}
    </MobileActionDialog>
  );
};

export default MobileFilters;
